export default "__VITE_ASSET__SgKzJtAx__"